export const staircaseConfig = {
    gameSlug: 'bart-risk',
    category: 'foudre_logique',
    variable: 'n_items',
    startValue: 16,
    minValue: 8,
    maxValue: 64,
    stepSizesByPhase: [8, 4, 2, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** 1 trial = 1 ballon (~10-20s) ; on cap à 10 (~ 2-3 min). */
    maxTrials: 10,
    direction: 'up-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            maxPumps: 16,
            rewardPerPump: 1,
            showLiveCounter: true,
            label: 'Ballons doux',
        };
    }
    if (level <= 20) {
        return {
            level,
            maxPumps: 24,
            rewardPerPump: 1,
            showLiveCounter: true,
            label: 'Ballons souples',
        };
    }
    if (level <= 30) {
        return {
            level,
            maxPumps: 32,
            rewardPerPump: 1,
            showLiveCounter: false,
            label: 'Compteur caché',
        };
    }
    if (level <= 40) {
        return {
            level,
            maxPumps: 48,
            rewardPerPump: 2,
            showLiveCounter: false,
            label: 'Reward × 2',
        };
    }
    return {
        level,
        maxPumps: 64,
        rewardPerPump: 3,
        showLiveCounter: false,
        label: 'Volatilité haute',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    prepareMs: 800,
    pumpAnimMs: 180,
    feedbackMs: 1500,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'bart-risk',
    paradigm: 'Balloon Analogue Risk Task (Lejuez 2002)',
    category: 'decision',
    goal: "Pompe pour gagner, encaisse avant l'explosion. Trouve l'équilibre.",
};
//# sourceMappingURL=params.js.map